/* @flow */
import React from 'react';
import { debounce } from 'lodash';

import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import SearchBlock from 'components/SearchBlock.jsx';
import AccountLinkingComposerSidebarContentList from './AccountLinkingComposerSidebarContentList.jsx';
import Image from 'components/Image.jsx';

import './styles/AccountLinkingComposerSidebarContent.scss';

type Props = {
  onViewSources: () => void,
  addLinkedContent: (*) => void,
  contentSource: *,
};

type State = {
  query: string,
};

class AccountLinkingComposerSidebarContent extends React.Component<Props, State> {
  state = {
    query: '',
  };

  performSearch = (rawQuery: string = '') => {
    const query = rawQuery.trim();
    this.setState({
      query,
    });
  };

  handleQueryChange = debounce(this.performSearch, 500, { leading: false, trailing: true });

  render() {
    const { contentSource, onViewSources, addLinkedContent } = this.props;
    const { query } = this.state;
    return (
      <div className="AccountLinkingComposerSidebarContent">
        <div className="AccountLinkingComposerSidebarContent-header">
          <Button
            aria-label="Back"
            className="AccountLinkingComposerSidebarContent-header-backButton"
            level="icon"
            weight="normal"
            size="large"
            onClick={onViewSources}>
            <Glyph name="arrow-left" size="medium" solo />
          </Button>
          <Image
            className="AccountLinkingComposerSidebarContent-header-icon"
            src={contentSource.iconURL}
          />
          <Text
            className="AccountLinkingComposerSidebarContent-header-title"
            align="center"
            size="large"
            color="pitch">
            {contentSource.title}
          </Text>
        </div>
        <SearchBlock
          className="AccountLinkingComposerSidebarContent-search"
          label="Search"
          glyphSize="small"
          noBorder
          onDismiss={() => {}}
          onQueryChange={this.handleQueryChange}
          data-test-selector="linked_content_search_input"
        />
        <div className="AccountLinkingComposerSidebarContent-content">
          <AccountLinkingComposerSidebarContentList
            contentSource={contentSource}
            query={query}
            addLinkedContent={addLinkedContent}
          />
        </div>
      </div>
    );
  }
}

export default AccountLinkingComposerSidebarContent;
